/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
  Tr,
  Td,
  TdPrice,
  AddRemoveButton,
  SVGWrapper,
  RequiredLabel,
  InputContainer,
  InputLabel,
  InputWrapper
} from './css';
import AddSVG from '../assets/svg/add';
import RemoveSVG from '../assets/svg/remove';
import { deleteOption } from './saveSchemaToDB';

const Option = ({
  optionData,
  isFirst,
  isLast,
  groupIndex,
  serviceIndex,
  questionIndex,
  optionIndex,
  fullyManagedAdminData,
  setFullyManagedAdminData,
  setInitialData,
  deleteOptions,
  setDeleteOptions,
}) => {
  const { name: label, productCatalogPricings} = optionData;
  let cost = 0;
  let onetimePrice = 0;
  let costPremium = 0;
  let onetimePricePremium = 0;
  if (productCatalogPricings && productCatalogPricings.length > 0) {
    // Safely destructure if quantityData[0] exists
    [{cost, onetimePrice, costPremium, onetimePricePremium }] = productCatalogPricings;
}

  const [optionLabel, setOptionLabel] = useState(label);
  const [optionCost, setOptionCost] = useState(cost);
  const [optionPrice, setOptionPrice] = useState(onetimePrice);
  const [optionCostPremium, setOptionCostPremium] = useState(costPremium);
  const [optionPricePremium, setOptionPricePremium] = useState(onetimePricePremium);

  const handleAddOption = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    const questionId =clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[questionIndex].id;
    const optionId =clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[questionIndex].productCatalogOptions[optionIndex].id;
    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions.push({
    questionId:questionId || '',
      id: '',
      name: '',
      ord:'',
      productCatalogPricings:[{
        optionId:optionId || '',
        cost: 0,
      onetimePrice: 0,
      costPremium: 0,
      onetimePricePremium: 0
      }]
      
    });
    setFullyManagedAdminData(clonedAdminData);
  };

  const handleRemoveOption = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    const optionId = clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
        questionIndex
      ].productCatalogOptions[optionIndex].id;
      if(optionId)
      {
        setDeleteOptions(prevData=>[...prevData,optionId]);
      }

    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions.splice(optionIndex, 1);
    setFullyManagedAdminData(clonedAdminData);
  };

  useEffect(() => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions[optionIndex].name = optionLabel;
    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions[optionIndex].productCatalogPricings[0].cost = optionCost;
    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions[optionIndex].productCatalogPricings[0].onetimePrice = optionPrice;
    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions[optionIndex].productCatalogPricings[0].costPremium = optionCostPremium;
    clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].productCatalogQuestions[
      questionIndex
    ].productCatalogOptions[optionIndex].productCatalogPricings[0].onetimePricePremium = optionPricePremium;
    setFullyManagedAdminData(clonedAdminData);
  }, [
    optionLabel,
    optionPrice,
    optionCost,
    optionCostPremium,
    optionPricePremium
  ]);

  return (
    <>
      {isFirst ? (
        <>
          <Td>
            <input
              type="text"
              value={optionLabel}
              style={{
                borderColor: label ? '#e4e4e4' : '#C12335'
              }}
              onChange={e => setOptionLabel(e.target.value)}
            />
            {!label && <RequiredLabel>Required</RequiredLabel>}
          </Td>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <InputLabel>Regular</InputLabel>
                <input
                  type="text"
                  value={`${optionCost}`}
                  style={{
                    borderColor: cost ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setOptionCost(e.target.value)}
                />
                {!cost && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Premium</InputLabel>
                <input
                  type="text"
                  value={`${optionCostPremium}`}
                  onChange={e => setOptionCostPremium(e.target.value)}
                />
              </InputContainer>
            </InputWrapper>
          </TdPrice>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <InputLabel>Regular</InputLabel>
                <input
                  type="text"
                  value={`${optionPrice}`}
                  style={{
                    borderColor: onetimePrice ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setOptionPrice(e.target.value)}
                />
                {!onetimePrice && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Premium</InputLabel>
                <input
                  type="text"
                  value={`${optionPricePremium}`}
                  onChange={e => setOptionPricePremium(e.target.value)}
                />
              </InputContainer>
            </InputWrapper>
              <AddRemoveButton>
            {!isLast && (
              <SVGWrapper onClick={handleRemoveOption}>
                <RemoveSVG />
              </SVGWrapper>
              )} 
              {isLast && (
                <SVGWrapper onClick={handleAddOption}>
                  <AddSVG />
                </SVGWrapper>
              )}
              </AddRemoveButton>
          </TdPrice>
        </>
      ) : (
        <Tr>
          <Td></Td>
          <Td>
            <input
              type="text"
              value={optionLabel}
              style={{
                borderColor: label ? '#e4e4e4' : '#C12335'
              }}
              onChange={e => setOptionLabel(e.target.value)}
            />
            {!label && <RequiredLabel>Required</RequiredLabel>}
          </Td>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <InputLabel>Regular</InputLabel>
                <input
                  type="text"
                  value={`${optionCost}`}
                  style={{
                    borderColor: cost ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setOptionCost(e.target.value)}
                />
                {!cost && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Premium</InputLabel>
                <input
                  type="text"
                  value={`${optionCostPremium}`}
                  onChange={e => setOptionCostPremium(e.target.value)}
                />
              </InputContainer>
            </InputWrapper>
          </TdPrice>
          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <InputLabel>Regular</InputLabel>
                <input
                  type="text"
                  value={`${optionPrice}`}
                  style={{
                    borderColor: onetimePrice ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setOptionPrice(e.target.value)}
                />
                {!onetimePrice && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Premium</InputLabel>
                <input
                  type="text"
                  value={`${optionPricePremium}`}
                  onChange={e => setOptionPricePremium(e.target.value)}
                />
              </InputContainer>
            </InputWrapper>
            <AddRemoveButton>
              <SVGWrapper onClick={handleRemoveOption}>
                <RemoveSVG />
              </SVGWrapper>
              {isLast && (
                <SVGWrapper onClick={handleAddOption}>
                  <AddSVG />
                </SVGWrapper>
              )}
            </AddRemoveButton>
          </TdPrice>
        </Tr>
      )}
    </>
  );
};

export default Option;
